export default __webpack_public_path__ + "static/media/gitApi.7ebd80d2.jpg";